import React, {useEffect, useState} from 'react'
import {
    Card,
    CardBody,
    Row,
    Col,
    TabContent,
    TabPane,
    Nav,
    NavItem,
    NavLink,
    UncontrolledButtonDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem, FormGroup, Label, Button, Modal, ModalHeader, ModalBody, Container
} from 'reactstrap'
import {
  CDU_TYPE,
  AIR_TYPE,
  REFRIG_TYPE,
  REFRIG_CDU_TYPE,
  GRAPHPARAMETER,
  COLOR,
  UNIT_GROUP, METER_TYPE
} from '@common/constants'
import Spinner from '@components/@vuexy/spinner/Fallback-spinner'
import {
    buildChartFromParameter,
    isEmpty,
    getRoleName,
    convertToDatetimeUTC,
    buildExportChartFromParameter
} from '@common/utils'
import Chart from 'react-apexcharts'
import ApexCharts from 'apexcharts'
import moment from 'moment-timezone'
import Flatpickr from 'react-flatpickr'
import SweetAlert from 'react-bootstrap-sweetalert'
import classnames from 'classnames'
import NowPanelRight from '@screens/EquipmentDetail/components/NowPanelRight'
import '@assets/scss/plugins/forms/flatpickr/flatpickr.scss'
import 'flatpickr/dist/themes/light.css'
import {Download, Loader, Search} from 'react-feather'
import * as FileSaver from 'file-saver'
import * as XLSX from 'xlsx'
import * as IotApi from '@apis/iotData'

export default (props) => {
    const REAL_TIME_MODE = 1
    const typeCatagoryName = [props.equipment.typeCatagoryName]

    const tabsContent = []
    const periodList = [
        {
            text: 'Last 4 Hours',
            value: 4,
        },
        {
            text: 'Last 8 Hours',
            value: 8
        },
    ]
    const isTechnicianRole = getRoleName() === 'TECHNICIAN'

    const [activeTab, setActiveTab] = useState(REAL_TIME_MODE)
    const [prevPeriod, setPrevPeriod] = useState(4)
    const [periodDate, setPeriodDate] = useState(moment().format('YYYY-MM-DD'))
    const [isLoading, setLoading] = useState(true)

    const [data, setData] = useState({})
    const [averageData, setAverageData] = useState({})

    //NEW HISTORICAL FROM PARAMETER
    const [tempChart, setTempChart] = useState({})
    const [statusChart, setStatusChart] = useState({})
    const [pressureChart, setPressureChart] = useState({})
    const [currentChart, setCurrentChart] = useState({})
    const [voltageChart, setVoltageChart] = useState({})
    const [powerChart, setPowerChart] = useState({})
    const [performanceChart, setPerformanceChart] = useState({})
    const [superheatChart, setSuperHeatChart] = useState({})
    const [rpsChart, setRPSChart] = useState({})
    const [isLoadingExport, setLoadingExport] = useState(false)
    const [downloadForm, setDownloadForm] = useState({
        dateFrom: moment().format('YYYY-MM-DD'),
        dateTo: moment().format('YYYY-MM-DD')
    })

    // SweetAlert
    const showAlert = (type, header, message, callback, showCancel = false) => {
        setAlertModel({
            isShow: true,
            header: header,
            message: message,
            type: type,
            callback: callback,
            showCancel: showCancel,
        })
    }

    const closeAlert = () => {
        setAlertModel({isShow: false, callback: closeAlert})
    }

    const [errMsg, setErrMsg] = useState('')
    const [alertModel, setAlertModel] = useState({isShow: false, callback: closeAlert})
    const [showExportModel, setShowExportModel] = useState(false)

    const renderErr = () => {
        showAlert('error', 'Error', `Error is ${errMsg}`, () => closeAlert())
        setErrMsg('')
    }

    const renderGraph = () => {
        switch (typeCatagoryName[0]) {
            case REFRIG_TYPE:
                return renderRefrigTypeMode()
            case REFRIG_CDU_TYPE:
                return renderRefrigCduTypeMode()
            case CDU_TYPE:
                return renderCduTypeMode()
            case AIR_TYPE:
                return renderAirTypeMode()
            case METER_TYPE:
                return renderMeterTypeMode()
            default:
                return null
        }
    }

    const renderRefrigTypeMode = () => {
        const {parametersArray} = props
        const {REFRIG_Temp, REFRIG_Status} = GRAPHPARAMETER
        return (
            <Card>
                <CardBody>
                    {parametersArray.some(item => REFRIG_Temp.includes(item)) ? renderGraphTemp() : null}
                    {parametersArray.some(item => REFRIG_Status.includes(item)) ? renderGraphStatus() : null}
                </CardBody>
            </Card>
        )
    }

    const renderRefrigCduTypeMode = () => {
        const {parametersArray} = props
        const {REFRIG_CDU_Temp, REFRIG_CDU_Status, REFRIG_CDU_Performance} = GRAPHPARAMETER

        return (
            <Card>
                <CardBody>
                    {parametersArray.some(item => REFRIG_CDU_Temp.includes(item)) ? renderGraphTemp() : null}
                    {parametersArray.some(item => REFRIG_CDU_Status.includes(item)) ? renderGraphStatus() : null}
                    {parametersArray.some(item => REFRIG_CDU_Performance.includes(item)) ? renderGraphComp() : null}
                </CardBody>
            </Card>
        )
    }

    const renderCduTypeMode = () => {
        const {parametersArray} = props
        const {
            CDU_Temp, CDU_Pressure, CDU_Status,
            CDU_Current, CDU_Performance, CDU_Superheat
        } = GRAPHPARAMETER

        return (
            <Card>
                <CardBody>
                    {parametersArray.some(item => CDU_Temp.includes(item)) ? renderGraphTemp() : null}
                    {parametersArray.some(item => CDU_Status.includes(item)) ? renderGraphStatus() : null}
                    {parametersArray.some(item => CDU_Pressure.includes(item)) ? renderGraphPressure() : null}
                    {parametersArray.some(item => CDU_Current.includes(item)) ? renderGraphCurrent() : null}
                    {parametersArray.some(item => CDU_Performance.includes(item)) ? renderGraphPerformance() : null}
                    {parametersArray.some(item => CDU_Superheat.includes(item)) ? renderGraphSuperheat() : null}
                </CardBody>
            </Card>
        )
    }

    const renderAirTypeMode = () => {
        const {parametersArray} = props
        const {AIR_Temp, AIR_Status, AIR_Current, AIR_RPS} = GRAPHPARAMETER

        return (
            <Card>
                <CardBody>
                    {parametersArray.some(item => AIR_Temp.includes(item)) ? renderGraphTemp() : null}
                    {parametersArray.some(item => AIR_Status.includes(item)) ? renderGraphStatus() : null}
                    {parametersArray.some(item => AIR_Current.includes(item)) ? renderGraphCurrent() : null}
                    {parametersArray.some(item => AIR_RPS.includes(item)) ? renderGraphRPS() : null}
                </CardBody>
            </Card>
        )
    }

    const renderMeterTypeMode = () => {
      const {parametersArray} = props
      const {METER_Current, METER_Voltage, METER_Status, METER_Power} = GRAPHPARAMETER
      return (
        <Card>
          <CardBody>
            {parametersArray.some(item => METER_Status.includes(item)) ? renderGraphStatus() : null}
            {parametersArray.some(item => METER_Current.includes(item)) ? renderGraphCurrent() : null}
            {parametersArray.some(item => METER_Voltage.includes(item)) ? renderGraphVoltage() : null}
            {parametersArray.some(item => METER_Power.includes(item)) ? renderGraphPower() : null}
          </CardBody>
        </Card>
      )
    }

    const renderGraphTemp = () => {
        return (
            <Chart
                options={{
                    ...defaultChartOption,
                    chart: {id: UNIT_GROUP.TEMP, group: 'now-page-chart'},
                    stroke: {width: 2},
                    fill: {opacity: 0.3},
                    colors: tempChart?.colors,
                    yaxis: tempYaxis
                }}
                series={tempChart?.series || []}
                height={250}
                width={'100%'}
            />
        )
    }

    const renderGraphStatus = () => {
        return (
            <Chart
                options={{
                    ...defaultChartOption,
                    chart: {id: UNIT_GROUP.STATUS, group: 'now-page-chart'},
                    stroke: {width: 1.5, curve: 'stepline'},
                    fill: {opacity: 0.2},
                    colors: statusChart?.colors,
                    yaxis: statusYaxis
                }}
                series={statusChart?.series || []}
                height={180}
                width={'100%'}
            />
        )
    }

    const renderGraphPressure = () => {
        return (
            <Chart
                options={{
                    ...defaultChartOption,
                    chart: {id: UNIT_GROUP.PRESSURE, group: 'now-page-chart'},
                    stroke: {width: [2, 2, 1]},
                    fill: {opacity: [0.3, 0.3, 0.5]},
                    colors: pressureChart?.colors,
                    // colors: [GRAPH_COLOR.PRESSURE.LOW, GRAPH_COLOR.PRESSURE.HIGH],
                    yaxis: pressureYaxis
                }}
                series={pressureChart?.series || []}
                height={250}
                width={'100%'}
            />
        )
    }

    const renderGraphCurrent = () => {
        return (
            <Chart
                options={{
                    ...defaultChartOption,
                    chart: {id: UNIT_GROUP.CURRENT, group: 'now-page-chart', type: 'area'},
                    stroke: {width: [2, 2, 1]},
                    fill: {opacity: [0.3, 0.3, 0.5]},
                    colors: currentChart?.colors,
                    // colors: [GRAPH_COLOR.CURRENT.C1, GRAPH_COLOR.CURRENT.C2],
                    yaxis: currentYaxis
                }}
                series={currentChart?.series || []}
                height={250}
                width={'100%'}
                type="area"
            />
        )
    }

    const renderGraphVoltage = () => {
        return (
            <Chart
                options={{
                    ...defaultChartOption,
                    chart: {id: UNIT_GROUP.VOLTAGE, group: 'now-page-chart', type: 'area'},
                    stroke: {width: [2, 2, 1]},
                    fill: {opacity: [0.3, 0.3, 0.5]},
                    colors: voltageChart?.colors,
                    yaxis: voltageYaxis
                }}
                series={voltageChart?.series || []}
                height={250}
                width={'100%'}
                type="area"
            />
        )
    }

    const renderGraphPower = () => {
        return (
            <Chart
                options={{
                    ...defaultChartOption,
                    chart: {id: UNIT_GROUP.POWER, group: 'now-page-chart', type: 'area'},
                    stroke: {width: [2, 2, 1]},
                    fill: {opacity: [0.3, 0.3, 0.5]},
                    colors: powerChart?.colors,
                    yaxis: powerYaxis
                }}
                series={powerChart?.series || []}
                height={250}
                width={'100%'}
                type="area"
            />
        )
    }

    const renderGraphRPS = () => {
        return (
            <Chart
                options={{
                    ...defaultChartOption,
                    chart: {id: UNIT_GROUP.RPS, group: 'now-page-chart', type: 'area'},
                    stroke: {width: 2},
                    fill: {opacity: 0.3},
                    colors: rpsChart?.colors,
                    yaxis: rpsYaxis
                }}
                series={rpsChart?.series || []}
                height={250}
                width={'100%'}
                type="area"
            />
        )
    }

    const renderGraphComp = () => {
        return (
            <Chart
                options={{
                    ...defaultChartOption,
                    chart: {id: 'comp-chart', group: 'now-page-chart'},
                    stroke: {width: [2]},
                    fill: {opacity: [0.3]},
                    colors: performanceChart?.colors,
                    yaxis: compYaxis
                }}
                series={performanceChart?.series || []}
                height={120}
                width={'100%'}
            />
        )
    }

    const renderGraphPerformance = () => {
        return (
            <Chart
                options={{
                    ...defaultChartOption,
                    chart: {id: UNIT_GROUP.PERFORMANCE, group: 'now-page-chart'},
                    stroke: {width: [2, 2, 1]},
                    fill: {opacity: [0.3, 0.3, 0.5]},
                    colors: performanceChart?.colors,
                    // colors: [GRAPH_COLOR.PERFORMANCE.FAN, GRAPH_COLOR.PERFORMANCE.COMP, GRAPH_COLOR.PERFORMANCE.OIL],
                    yaxis: performanceYaxis
                }}
                series={performanceChart?.series || []}
                height={250}
                width={'100%'}
            />
        )
    }

    const renderGraphSuperheat = () => {
        return (
            <Chart
                options={{
                    ...defaultChartOption,
                    chart: {id: UNIT_GROUP.SUPERHEAT, group: 'now-page-chart'},
                    stroke: {width: [2, 2, 1]},
                    fill: {opacity: [0.3, 0.3, 0.5]},
                    colors: superheatChart?.colors,
                    // colors: [GRAPH_COLOR.PRESSURE.HIGH, GRAPH_COLOR.PRESSURE.LOW],
                    yaxis: superheatYaxis
                }}
                series={superheatChart?.series || []}
                height={250}
                width={'100%'}
            />
        )
    }

    const tabsMenu = [
        {
            id: '1',
            title: 'Realtime',
            content: renderGraph(),
        },
        {
            id: '2',
            title: '1 Day',
            content: renderGraph(),
        },
    ]

    const setDataRealtime = () => {
        try {
            let chartData = {}
            let historicalTempChartSeries = tempChart.series

            const oldChartsData = {
                tempChart, statusChart, pressureChart, currentChart, voltageChart, powerChart, performanceChart, superheatChart, rpsChart
            }

            // When toggle period will reset graph (4 or 8 hours)
            if (props.graphPeriod !== prevPeriod) {
                historicalTempChartSeries = {}

                setPrevPeriod(props.graphPeriod)
            }

            // For real time incoming data
            if (historicalTempChartSeries && historicalTempChartSeries?.length > 0 && historicalTempChartSeries[0].data?.length > 0) {
                const oldDataDate = historicalTempChartSeries[0].data.slice(-1)[0].x
                if (props.iotData && props.iotData.readDate > oldDataDate) {
                    chartData = buildChartFromParameter(props.parametersDataByGroup, oldChartsData, [props.iotData], 'NOWTAB')
                    updateChart(chartData)
                }
            } else {
                chartData = buildChartFromParameter(props.parametersDataByGroup, null, props.historicalData, 'NOWTAB')
            }

            setData(props.iotData)
            if (props.averageData) setAverageData(...props.averageData)

            if (!isEmpty(chartData)) {
                setTempChart(chartData.tempChartData)
                setStatusChart(chartData.statusChartData)
                setPressureChart(chartData.pressureChartData)
                setCurrentChart(chartData.currentChartData)
                setVoltageChart(chartData.voltageChartData)
                setPowerChart(chartData.powerChartData)
                setPerformanceChart(chartData.performanceChartData)
                setSuperHeatChart(chartData.superheatChartData)
                setRPSChart(chartData.rpsChartData)
            }

        } catch (error) {
            setErrMsg(error)
        }
    }

    const setDataOneDay = () => {
        try {
            let chartData = []

            if (props.historicalData.length > 0) {
                const historicalDate = moment(props.historicalData.slice(-1)[0].readDate).format('YYYY-MM-DD')
                historicalDate !== periodDate ? setPeriodDate(historicalDate) : ''
            }

            chartData = buildChartFromParameter(props.parametersDataByGroup, null, props.historicalData, 'NOWTAB')

            if (props.averageData) setAverageData(...props.averageData)
            setTempChart(chartData.tempChartData)
            setStatusChart(chartData.statusChartData)
            setPressureChart(chartData.pressureChartData)
            setCurrentChart(chartData.currentChartData)
            setVoltageChart(chartData.voltageChartData)
            setPowerChart(chartData.powerChartData)
            setPerformanceChart(chartData.performanceChartData)
            setSuperHeatChart(chartData.superheatChartData)
            setRPSChart(chartData.rpsChartData)
        } catch (error) {
            setErrMsg(error)
        }
    }

    const updateChart = (newChartsData) => {
        ApexCharts.exec(UNIT_GROUP.TEMP, 'updateSeries', newChartsData.tempChartData.series)
        ApexCharts.exec(UNIT_GROUP.STATUS, 'updateSeries', newChartsData.statusChartData.series)
        ApexCharts.exec(UNIT_GROUP.PRESSURE, 'updateSeries', newChartsData.pressureChartData.series)
        ApexCharts.exec(UNIT_GROUP.PERFORMANCE, 'updateSeries', newChartsData.pressureChartData.series)
        ApexCharts.exec(UNIT_GROUP.CURRENT, 'updateSeries', newChartsData.currentChartData.series)
        ApexCharts.exec(UNIT_GROUP.VOLTAGE, 'updateSeries', newChartsData.voltageChartData.series)
        ApexCharts.exec(UNIT_GROUP.POWER, 'updateSeries', newChartsData.powerChartData.series)
        ApexCharts.exec(UNIT_GROUP.SUPERHEAT, 'updateSeries', newChartsData.superheatChartData.series)
        ApexCharts.exec(UNIT_GROUP.RPS, 'updateSeries', newChartsData.rpsChartData.series)
    }

    useEffect(() => {
        setLoading(true)
        activeTab === REAL_TIME_MODE ? setDataRealtime() : setDataOneDay()
        setLoading(false)
    }, [props.historicalData, props.graphPeriod])

    useEffect(() => {
        setLoading(true)
        setDataRealtime()
        setLoading(false)
    }, [props.iotData])

    useEffect(() => {
        renderGraph()
    }, [data])

    const initializeTabsContent = (tabNumber, tabContent) => {
        tabsContent.push(
            <TabPane key={tabNumber} tabId={tabNumber}>
                {tabContent || ''}
            </TabPane>
        )
    }

    const renderTabMenu = () => {
        const toggleTabHandler = (tab) => {
            activeTab !== tab ? setActiveTab(tab) : setActiveTab(activeTab)

            if (tab === REAL_TIME_MODE) {
                props.getHistoricalData(props.equipment.ukey, props.typeCatagoryName, prevPeriod, periodDate)
            } else { //One day mode
                props.getHistoricalData(props.equipment.ukey, props.typeCatagoryName, 24, periodDate)
            }
        }

        return tabsMenu.map((tabMenu, index) => {
            const tabNumber = index + 1
            initializeTabsContent(tabNumber, tabMenu.content)

            return (
                <div key={tabMenu.title}>
                    <NavItem>
                        <NavLink
                            className={classnames({
                                active: activeTab === tabNumber,
                            })}
                            disabled={isTechnicianRole && tabMenu.id !== '1'}
                            onClick={() => {
                                toggleTabHandler(tabNumber)
                            }}>
                            {tabMenu.title}
                        </NavLink>
                    </NavItem>
                </div>
            )
        })
    }

    const renderPeriodList = () => {
        return periodList.map((periodList, index) => {
            return (
                <DropdownItem
                    onClick={() => props.getHistoricalData(props.equipment.ukey, props.typeCatagoryName, periodList.value, periodDate)}
                    key={index}
                    disabled={isTechnicianRole}
                    tag="a">
                    {periodList.text}
                </DropdownItem>
            )
        })
    }

    const renderSelectedPeriod = (activeTab) => {
        return (
            <div className="ml-2">
                Selected period
                <div className="dropdown d-inline-block ml-2">
                    <UncontrolledButtonDropdown>
                        {activeTab === REAL_TIME_MODE ? (
                                <DropdownToggle outline color="light" caret>
                                    {`Last ${prevPeriod} Hours`}
                                </DropdownToggle>)
                            : <Flatpickr
                                className="form-control"
                                value={periodDate}
                                onChange={date => {
                                    props.getHistoricalData(props.equipment.ukey, props.typeCatagoryName, 24, date[0])
                                }}
                                options={{maxDate: 'today'}}
                            />
                        }
                        <DropdownMenu>
                            {renderPeriodList()}
                        </DropdownMenu>
                    </UncontrolledButtonDropdown>
                </div>
            </div>)
    }

    const getDownloadData = async (ukey, typeCategoryName, dateFrom, dateTo) => {
        let fetchFn
        switch (typeCategoryName) {
            case AIR_TYPE:
                fetchFn = IotApi.getHistoricalXWebAirData
                break
            case CDU_TYPE:
                fetchFn = IotApi.getHistoricalXWebCduData
                break
            case REFRIG_TYPE:
                fetchFn = IotApi.getHistoricalXWebData
                break
            case REFRIG_CDU_TYPE:
                fetchFn = IotApi.getHistoricalXWebData
                break
            case METER_TYPE:
                fetchFn = IotApi.getHistoricalXwebMeterData
                break
            default:
                fetchFn = null
        }
        if (fetchFn) {
            const fromDateUTC = convertToDatetimeUTC(moment(dateFrom).startOf('day'))
            const toDateUTC = dateTo ? convertToDatetimeUTC(moment(dateTo).endOf('day')) : null

            const res = await fetchFn(ukey, fromDateUTC, toDateUTC)
            if (res && res.data) return res.data.historical
        }

        return []
    }

    const onDownloadData = async () => {
        if (moment.duration(moment(downloadForm.dateTo).diff(moment(downloadForm.dateFrom))).asDays() < 0) {
            showAlert('warning', 'Warning', 'Start date must be less than or equal to end date.', () => closeAlert())
            return
        } else if (moment.duration(moment(downloadForm.dateTo).diff(moment(downloadForm.dateFrom))).asDays() > 7) {
            showAlert('warning', 'Warning', 'The period must not exceed 7 days.', () => closeAlert())
            return
        }

        setLoadingExport(true)
        const res = await getDownloadData(props.equipment.ukey, props.typeCatagoryName, downloadForm.dateFrom, downloadForm.dateTo)
        const header = {
            branchNo: props.shop.branchNo,
            branchName: props.shop.detail,
            province: props.shop.Province.name,
            equipmentName: props.equipment.assetNo,
        }
        const ws = XLSX.utils.json_to_sheet(buildExportChartFromParameter(props.parametersDataByGroup, res, header))
        const wb = {Sheets: {data: ws}, SheetNames: ['data']}
        const excelBuffer = XLSX.write(wb, {bookType: 'xlsx', type: 'array'})
        FileSaver.saveAs(new Blob([excelBuffer]), `${props.equipment.ukey}_${moment().format('YYYY-MM-DD HHmmss')}.xlsx`)
        setLoadingExport(false)
        setShowExportModel(false)
        showAlert('success', 'Success', 'Download complete', () => closeAlert())
    }

    const renderDownloadPeriod = () => {
        return (<Button color="primary" className="mt-1 pl-1 pr-1" outline disabled={isLoadingExport}
                        onClick={() => setShowExportModel(true)}>
            <Download size={15}/>
        </Button>)
    }

    const renderExportModal = () => {
        return (
            <Modal isOpen={showExportModel} toggle={() => setShowExportModel(false)}
                   className="modal-dialog-centered">
                <ModalHeader className="bg-primary" toggle={() => setShowExportModel(false)}>
                    Export data
                </ModalHeader>
                <ModalBody className="modal-dialog-centered">
                    <Row>
                        <Col sm="12">
                            From
                            <div className="dropdown d-inline-block ml-1 mr-1">
                                <UncontrolledButtonDropdown>
                                    <Flatpickr
                                        className="form-control"
                                        value={downloadForm.dateFrom}
                                        onChange={date => setDownloadForm({...downloadForm, dateFrom: date[0]})}
                                        options={{maxDate: 'today'}}
                                    />
                                </UncontrolledButtonDropdown>
                            </div>
                            to
                            <div className="dropdown d-inline-block ml-1">
                                <UncontrolledButtonDropdown>
                                    <Flatpickr
                                        className="form-control"
                                        value={downloadForm.dateTo}
                                        onChange={date => setDownloadForm({...downloadForm, dateTo: date[0]})}
                                        options={{maxDate: 'today'}}
                                    />
                                </UncontrolledButtonDropdown>
                            </div>
                        </Col>
                        <Col sm="12" className="text-center mt-1">
                            <div className="dropdown d-inline-block ml-1">
                                <UncontrolledButtonDropdown>
                                    <Button.Ripple color="primary" className="button-search" disabled={isLoadingExport}
                                                   onClick={onDownloadData}>
                                        {isLoadingExport ? <Loader size={17}/> : <Download size={17}/>} Download
                                    </Button.Ripple>
                                </UncontrolledButtonDropdown>
                            </div>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>
        )
    }

    if (isLoading) {
        return (
            <Row>
                <Spinner/>
            </Row>
        )
    }

    return (
        <>
            <Row>
                <Col lg="11" sm='10'>
                    <Nav tabs className="select-time-tab mt-1">
                        {renderTabMenu()}
                        {renderSelectedPeriod(activeTab)}
                    </Nav>
                </Col>
                <Col lg="1" sm='2' className='text-right'>
                    {renderDownloadPeriod()}
                </Col>
            </Row>
            <Row>
                <Col lg="8">
                    <TabContent activeTab={activeTab}>
                        {tabsContent.map((tabContent) => tabContent)}
                    </TabContent>
                </Col>
                <Col lg="4">
                    <NowPanelRight
                        activeTab={activeTab}
                        data={data}
                        averageData={averageData}
                        parameterDetailByGroup={props.parametersDataByGroup}
                        typeCatagoryName={typeCatagoryName}
                    />
                </Col>
            </Row>
            {renderExportModal()}
            {errMsg !== '' ? renderErr() : null}
            <div className="equipment-model-detail">
                <SweetAlert
                    type={alertModel.type}
                    title={alertModel.header || ''}
                    show={alertModel.isShow}
                    onConfirm={alertModel.callback}
                    onCancel={closeAlert}
                    showCancel={alertModel.showCancel}
                    showConfirm={alertModel.type === 'success' ? false : true}
                    reverseButtons
                    cancelBtnBsStyle="danger"
                    timeout={alertModel.type === 'success' ? 2000 : null}
                >
                    <p className="sweet-alert-text">{alertModel.message}</p>
                </SweetAlert>
            </div>
        </>
    )
}


const TEMP_C = 'Temp (°C)'

// Set Graph Style
const defaultChartOption = {
    dataLabels: {
        enabled: false
    },
    legend: {
        show: true,
        position: 'top',
        horizontalAlign: 'left',
    },
    xaxis: {
        type: 'datetime',
        labels: {
            formatter: function (value, timestamp) {
                return moment.utc(timestamp).local().format('HH:mm')
            },
            style: {
                colors: COLOR.DARKGREY,
            }
        },
        axisBorder: {
            show: false
        },
        axisTicks: {
            show: false
        }
    },
    tooltip: {
        fixed: {
            enabled: false,
            position: 'topRight'
        }
    },
    grid: {
        show: true,
        borderColor: COLOR.GREY,
        strokeDashArray: 3,
        position: 'back',
        opacity: 0.2,
        xaxis: {
            lines: {
                show: true
            }
        },
        yaxis: {
            lines: {
                show: true
            }
        }
    }
}

const tempYaxis = {
    tickAmount: 1,
    floating: false,
    labels: {
        style: {
            colors: COLOR.DARKGREY,
        },
        minWidth: 50,
        maxWidth: 50,
        offsetY: -7,
        offsetX: 0,
    },
    axisBorder: {
        show: false,
    },
    axisTicks: {
        show: false
    },
    title: {
        text: TEMP_C,
        style: {color: COLOR.TMD_GREY}
    }
}

const statusYaxis = {
    tickAmount: 1,
    floating: false,
    labels: {
        style: {
            colors: COLOR.DARKGREY,
        },
        minWidth: 50,
        maxWidth: 50,
        offsetY: -7,
        offsetX: 0,
    },
    axisBorder: {
        show: false,
    },
    axisTicks: {
        show: false
    },
    title: {
        text: 'Status',
        style: {color: COLOR.TMD_GREY}
    }
}

const compYaxis = {
    tickAmount: 1,
    floating: false,
    labels: {
        style: {
            colors: COLOR.DARKGREY,
        },
        minWidth: 50,
        maxWidth: 50,
        offsetY: -7,
        offsetX: 0,
    },
    axisBorder: {
        show: false,
    },
    axisTicks: {
        show: false
    },
    title: {
        text: 'Performance(%)',
        style: {color: COLOR.TMD_GREY}
    }
}

const pressureYaxis = {
    tickAmount: 1,
    floating: false,
    labels: {
        style: {
            colors: COLOR.DARKGREY,
        },
        minWidth: 50,
        maxWidth: 50,
        offsetY: -7,
        offsetX: 0,
    },
    axisBorder: {
        show: false,
    },
    axisTicks: {
        show: false
    },
    title: {
        text: 'Pressure(bar)',
        style: {color: COLOR.TMD_GREY}
    }
}

const currentYaxis = {
    tickAmount: 1,
    floating: false,
    labels: {
        style: {
            colors: COLOR.DARKGREY,
        },
        minWidth: 50,
        maxWidth: 50,
        offsetY: -7,
        offsetX: 0,
    },
    axisBorder: {
        show: false,
    },
    axisTicks: {
        show: false
    },
    title: {
        text: 'Current(Amp)',
        style: {color: COLOR.TMD_GREY}
    }
}

const voltageYaxis = {
    tickAmount: 1,
    floating: false,
    labels: {
        style: {
            colors: COLOR.DARKGREY,
        },
        minWidth: 50,
        maxWidth: 50,
        offsetY: -7,
        offsetX: 0,
    },
    axisBorder: {
        show: false,
    },
    axisTicks: {
        show: false
    },
    title: {
        text: 'Voltage(Volt)',
        style: {color: COLOR.TMD_GREY}
    }
}

const powerYaxis = {
    tickAmount: 1,
    floating: false,
    labels: {
        style: {
            colors: COLOR.DARKGREY,
        },
        minWidth: 50,
        maxWidth: 50,
        offsetY: -7,
        offsetX: 0,
    },
    axisBorder: {
        show: false,
    },
    axisTicks: {
        show: false
    },
    title: {
        text: 'Power(W)',
        style: {color: COLOR.TMD_GREY}
    }
}

const rpsYaxis = {
    tickAmount: 1,
    floating: false,
    labels: {
        style: {
            colors: COLOR.DARKGREY,
        },
        minWidth: 50,
        maxWidth: 50,
        offsetY: -7,
        offsetX: 0,
    },
    axisBorder: {
        show: false,
    },
    axisTicks: {
        show: false
    },
    title: {
        text: 'RPS(RPS)',
        style: {color: COLOR.TMD_GREY}
    }
}

const performanceYaxis = {
    tickAmount: 1,
    floating: false,
    labels: {
        style: {
            colors: COLOR.DARKGREY,
        },
        minWidth: 50,
        maxWidth: 50,
        offsetY: -7,
        offsetX: 0,
    },
    axisBorder: {
        show: false,
    },
    axisTicks: {
        show: false
    },
    title: {
        text: 'Performance(%)',
        style: {color: COLOR.TMD_GREY}
    }
}

const superheatYaxis = {
    tickAmount: 1,
    floating: false,
    labels: {
        style: {
            colors: COLOR.DARKGREY,
        },
        minWidth: 50,
        maxWidth: 50,
        offsetY: -7,
        offsetX: 0,
    },
    axisBorder: {
        show: false,
    },
    axisTicks: {
        show: false
    },
    title: {
        text: 'Superheat',
        style: {color: COLOR.TMD_GREY}
    }
}
